import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import "./Layout.styles.scss";
import { Link } from "react-router-dom";
import AuthMiddleware from "../../store/middleware/authMiddleware";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import TopbarNotification from "../notification/Notification";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import CogOutlineIcon from "@material-ui/icons/Settings";
import Path from "../../services/paths";
import utils from "../../store/common/utils";
import ChangePasswordAfterLogin from "../../screen/change-password/changePasswordAfterLogin";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      is_superuser: false,
      sfos: true,
      top: false,
      left: false,
      prat: true,
      isGtForm: true,
      onlySfos: false,
      onlyPrat: false,
      dropDownDashboard: false,
      dropDownReports: false,
      dropDownSuperuser: false,
      changePasswordInternalModal: false,
      list: [
        {
          label: "Dashboard",
          subList: [
            {
              label: "Primary",
              link: "/primarydashboard",
            },
            {
              label: "Secondary",
              link: "/secondarydashboard",
            },
          ],
        },
        {
          label: "Demand Plan",
        },
        {
          label: "Reports",
          subList: [
            {
              label: "Total Demand Graph",
              link: "/forcastdetail",
            },
            {
              label: "FA/FB-Report",
              link: "/FA/FB-Report",
            },
          ],
        },
      ],
      display: false,
      pratReports: true,
    };
  }
  toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    this.setState({ ...this.state, [side]: open });
  };

  handleDemandPlanner = () => {
    this.props.history.push("/demandplanner");
    this.setState({ left: false });
  };

  handleDropdownDashboard = () => {
    this.setState({
      dropDownDashboard: !this.state.dropDownDashboard,
    });
  };

  handleDropdownReports = () => {
    this.setState({
      dropDownReports: !this.state.dropDownReports,
    });
  };
  handleOutSideClick = () => {
    this.setState({
      display: false,
    });
    document.removeEventListener("click", this.handleOutSideClick);
  };
  handleDropdownSuperuser = () => {
    this.setState({ dropDownSuperuser: !this.state.dropDownSuperuser });
  };

  handleLogout = (e) => {
    // this.props.LogOut();
    this.callLogOutAPI();
  };

  callLogOutAPI = () => {
    try {
      utils.get_token().then((token) => {
        fetch(Path.LOG_OUT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.status === 200) {
              // console.log(res)
              this.props.LogOut();
            } else {
              throw "error";      //eslint-disable-line
            }
          });
      });
    } catch (error) {}
  };

  componentDidMount() {
    // let isUser = JSON.parse(localStorage.getItem("myData"));
    // let tokenExpiryDateFromStorage = JSON.parse(
    //   localStorage.getItem("expiryDate")
    // );
    // let convertStoredDate = new Date(tokenExpiryDateFromStorage);

    // let d = convertStoredDate.getDate();
    // let m = convertStoredDate.getMonth();
    // let y = convertStoredDate.getFullYear();
    // let expireDate = d + "-" + m + "-" + y;

    // let currentDate = new Date();
    // let currentDay = currentDate.getDate();
    // let currentMonth = currentDate.getMonth();
    // let currentYear = currentDate.getFullYear();
    // let checkDate = currentDay + "-" + currentMonth + "-" + currentYear;

    // if (expireDate === checkDate || (d <= currentDay || m < currentMonth)) {
    //   AuthMiddleware.refreshToken(isUser.refresh_token)
    // } else {
    // }
  }

  handleAdminPannel = (e) => {
    e.preventDefault();
    window.open(Path.DJANGO_ADMIN_PANNEL, "_blank");
  };

  handleChangePassword = () => {
    this.setState({ changePasswordInternalModal: true });
  };

  handleCloseModal = () => {
    this.setState({ changePasswordInternalModal: false });
  };

  render() {
    const user = JSON.parse(localStorage.getItem("myData"));

    return (
      <div className="root-container">
        <AppBar position="static" className="container-toolbar">
          <Toolbar className="toolbar">
            <div className="prat-sfos-dropdown-container">
              <div
                className="prat-sfos-heading"
                onClick={() => {
                  this.setState({ top: !this.state.top });
                }}
              >
                <Typography className="logo-name">
                  {" "}
                  {window.location.pathname.substr(0, 7) === "/gtform" ||
                  window.location.pathname.substr(0, 18) ===
                    "/promotionapproval" ||
                  window.location.pathname === "/promotionlist" ||
                  window.location.pathname === "/activityplan" ||
                  window.location.pathname === "/accrualreport" ||
                  window.location.pathname === "/preandpostopso" ||
                  window.location.pathname === "/activitynetwork" ||
                  window.location.pathname === "/schemereport" ||
                  window.location.pathname === "/pratdashboard"
                    ? "PRAT"
                    : "SFOS"}
                </Typography>
                <img
                  className="dropdown-arrow-prat-sfos"
                  style={
                    this.state.top ? { transform: "rotate(180deg)" } : null
                  }
                  src={require("../../assets/images/dropdownArrow.svg")}
                  alt=""
                />
              </div>

              {this.state.top ? (
                <ClickAwayListener
                  onClickAway={() => {
                    this.setState({ top: false });
                  }}
                >
                  <div
                    className="prat-sfos-dropdown"
                    onClick={() => {
                      this.setState({ top: false });
                    }}
                  >
                    {(user.user.is_superuser && user.user.sfos_allowed) ||
                    user.user.sfos_allowed ||
                    user.user.is_superuser ? (
                      <span
                        className="dropdown-span"
                        onClick={() => {
                          this.props.history.push("/primarydashboard");
                        }}
                      >
                        SFOS
                      </span>
                    ) : null}

                    {(user.user.is_superuser && user.user.prat_allowed) ||
                    user.user.prat_allowed ||
                    user.user.is_superuser ? (
                      <span
                        className="dropdown-span"
                        onClick={() => {
                          this.props.history.push("/pratdashboard");
                        }}
                      >
                        PRAT
                      </span>
                    ) : null}
                  </div>
                </ClickAwayListener>
              ) : null}
            </div>

            {window.location.pathname.substr(0, 7) === "/gtform" ||
            window.location.pathname.substr(0, 18) === "/promotionapproval" ||
            window.location.pathname === "/promotionlist" ||
            window.location.pathname === "/activityplan" ||
            window.location.pathname === "/accrualreport" ||
            window.location.pathname === "/preandpostopso" ||
            window.location.pathname === "/activitynetwork" ||
            window.location.pathname === "/schemereport" ||
            window.location.pathname === "/pratdashboard" ? (
              // PRAT MENU
              <div className="sfos-list-container">
                <div className="sfos-list-item">
                  <span
                    onClick={() => {
                      this.props.history.push("/pratdashboard");
                    }}
                  >
                    Dashboard
                  </span>
                </div>

                <div className="sfos-list-item">
                  <span
                    onClick={() => {
                      this.props.history.push("/promotionlist");
                    }}
                  >
                    Promotion List
                  </span>
                </div>

                <div>
                  <div
                    className="sfos-list-item"
                    onClick={() => {
                      this.setState({
                        dropDownReports: !this.state.dropDownReports,
                      });
                    }}
                  >
                    <span>Reports</span>
                    <img
                      className="sfos-list-img"
                      style={
                        this.state.dropDownReports
                          ? { transform: "rotate(180deg)" }
                          : null
                      }
                      src={require("../../assets/images/dropdownArrow.svg")}
                      alt=""
                    />
                  </div>

                  {this.state.dropDownReports ? (
                    <ClickAwayListener
                      onClickAway={() => {
                        this.setState({ dropDownReports: false });
                      }}
                    >
                      <div
                        className="dropdown-list-container"
                        onClick={() => {
                          this.setState({ dropDownReports: false });
                        }}
                      >
                        <Link className="list-item" to="/activityplan">
                          Activity Plan
                        </Link>
                        {user.user.groups[0] === "CDF" ? (
                          <Link className="list-item" to="/accrualreport">
                            Accrual Report
                          </Link>
                        ) : null}
                        <Link className="list-item" to="/activitynetwork">
                          Activity Network
                        </Link>
                        {user.user.groups[0] === "CD-MIS" ? (
                          <Link className="list-item" to="/schemereport">
                            Scheme Report
                          </Link>
                        ) : null}
                        <Link className="list-item" to="/preandpostopso">
                          Pre vs Post OPSO Report
                        </Link>
                      </div>
                    </ClickAwayListener>
                  ) : null}
                </div>
              </div>
            ) : (
              // SFOS MENU
              <div className="sfos-list-container">
                <div>
                  <div
                    className="sfos-list-item"
                    onClick={() => {
                      this.setState({
                        dropDownDashboard: !this.state.dropDownDashboard,
                      });
                    }}
                  >
                    <span>Dashboard</span>
                    <img
                      className="sfos-list-img"
                      style={
                        this.state.dropDownDashboard
                          ? { transform: "rotate(180deg)" }
                          : null
                      }
                      src={require("../../assets/images/dropdownArrow.svg")}
                      alt=""
                    />
                  </div>

                  {this.state.dropDownDashboard ? (
                    <ClickAwayListener
                      onClickAway={() => {
                        this.setState({ dropDownDashboard: false });
                      }}
                    >
                      <div
                        className="dropdown-list-container"
                        onClick={() => {
                          this.setState({ dropDownDashboard: false });
                        }}
                      >
                        <Link className="list-item" to="/primarydashboard">
                          Primary Dashboard
                        </Link>
                        <Link className="list-item" to="/secondarydashboard">
                          Secondary Dashboard
                        </Link>
                      </div>
                    </ClickAwayListener>
                  ) : null}
                </div>

                <div className="sfos-list-item">
                  <span
                    onClick={() => {
                      this.props.history.push("/demandplanner");
                    }}
                  >
                    Demand Planner
                  </span>
                </div>

                <div>
                  <div
                    className="sfos-list-item"
                    onClick={() => {
                      this.setState({
                        dropDownReports: !this.state.dropDownReports,
                      });
                    }}
                  >
                    <span>Reports</span>
                    <img
                      className="sfos-list-img"
                      style={
                        this.state.dropDownReports
                          ? { transform: "rotate(180deg)" }
                          : null
                      }
                      src={require("../../assets/images/dropdownArrow.svg")}
                      alt=""
                    />
                  </div>

                  {this.state.dropDownReports ? (
                    <ClickAwayListener
                      onClickAway={() => {
                        this.setState({ dropDownReports: false });
                      }}
                    >
                      <div
                        className="dropdown-list-container"
                        onClick={() => {
                          this.setState({ dropDownReports: false });
                        }}
                      >
                        <Link className="list-item" to="/forcastdetail">
                          Total Demand Graph
                        </Link>
                        <Link className="list-item" to="/FA/FB-Report">
                          FA/FB-Report
                        </Link>
                        <Link className="list-item" to="baselinegraph">
                          Baseline Graph
                        </Link>
                      </div>
                    </ClickAwayListener>
                  ) : null}
                </div>
              </div>
            )}

            <div className="spacer"></div>
            <TopbarNotification />
            <div
              className="custom-dropdown"
              onMouseDown={(e) => {
                e.preventDefault();
              }}
            >
              <div
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    display: !this.state.display,
                  });
                  document.addEventListener("click", this.handleOutSideClick);
                }}
                className="clickDropdown"
              >
                <p className="user-title">
                  {user.user.first_name ? (
                    user.user.first_name
                  ) : (
                    <span>&emsp;&emsp;</span>
                  )}{" "}
                  {user.user.last_name ? (
                    user.user.last_name
                  ) : (
                    <span>&emsp;&emsp;</span>
                  )}
                </p>
                <Avatar
                  className="avatar"
                  alt={user.user.first_name}
                  src="/static/images/avatar/1.jpg"
                />
              </div>

              {this.state.display ? (
                <div className="dropdown-menu">
                  {user.user.groups[0] === "System Admin" ?
                    <span
                    className="dropdown-menu-item"
                    onClick={(e) => this.handleAdminPannel(e)}
                  >
                    <CogOutlineIcon />
                    <p className="dropdown-menu-item-text">Django Admin</p>
                  </span>
                  : 
                  null
                  }

                  <span
                    className="dropdown-menu-item"
                    onClick={() => this.handleChangePassword()}
                  >
                    <ExitToAppIcon />
                    <p className="dropdown-menu-item-text">Change Password</p>
                  </span>

                  <span
                    className="dropdown-menu-item"
                    onClick={(e) => this.handleLogout(e)}
                  >
                    <ExitToAppIcon />
                    <p className="dropdown-menu-item-text">Logout</p>
                  </span>
                </div>
              ) : null}
            </div>
            {this.state.changePasswordInternalModal && (
              <ChangePasswordAfterLogin
                handleCloseModal={this.handleCloseModal}
                flag={this.state.changePasswordInternalModal}
              />
            )}
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const mapStateToprops = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    LogOut: () => {
      dispatch(AuthMiddleware.logOut());
    },
  };
};

export default withRouter(connect(mapStateToprops, mapDispatchToProps)(Layout));
